module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-SemiBold.1d0f58a1.ttf";